export default __webpack_public_path__ + "e48918f9c91871c0ce3ecf2a3ee0a416.woff2";